import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Button } from 'reactstrap';

import { connect } from 'react-redux';
import { PostAction } from 'redux/actions';
import { useParams } from "react-router-dom";
import PopupWindow from 'components/ModalPopup';
import PostUsers from './postUsers';
import ImageCarousel from 'components/carousel';
import { useNavigate } from 'react-router-dom';
import { checkPermissions, DateFormat } from 'hooks';
import Skeleton from '@mui/material/Skeleton';
import { Map, TileLayer, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import markerIconImage from 'assets/img/marker-icon.png';
import L from "leaflet";

const PostDetails = (props) => {
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = React.useState('ABOUT');
    const { postId } = useParams();
    const isFirstRender = React.useRef(true);
    const [pagination] = React.useState({
        page: 0,
        page_limit: 10,
    })
    const [order] = React.useState({
        order_by: 'name',
        direction: 'asc'
    })

    const markerIcon = new L.Icon({
        iconUrl: markerIconImage,
        iconSize: [25, 41],
        iconAnchor: [10, 41],
        popupAnchor: [2, -40]
    });

    React.useEffect(() => {

        if (isFirstRender.current) {
            const filters = { id: postId, page: pagination.page, page_limit: pagination.page_limit, order_by: order.order_by, direction: order.direction };
            props.getReportedBy(filters);
            props.getViewedBy(filters);
            props.getPostDetails({ id: postId })
            isFirstRender.current = false;

        }
    })
    const handleTab = (tab) => {
        setActiveTab(tab)
    }

    React.useEffect(() => {
        if (props.postDeleted) {
            navigate('/reported-posts');
        }
    }, [props.postDeleted])

    return (
        <Row>
            <Col sm="12" lg="3">
                <ImageCarousel items={props.postDetails} />

                {checkPermissions(props.loginData, 'delete_post') ?
                    <PopupWindow buttonStyle={{ marginTop: 10, width: '100%' }} handlePopup={(popup) => { setOpen(popup) }} openWindow={open} title={'Delete Post'} launchButtonText={'Delete Post'} >
                        <div>
                            <div>
                                Are you sure? Do you want to delete this post?
                            </div>
                            <div style={{ display: 'flex' }}>
                                <Button
                                    style={{ padding: 'auto', width: 100, marginTop: 20, marginRight: 10 }}
                                    size="sm"
                                    onClick={() => {
                                        props.deletePost({ id: postId })
                                    }}
                                    block >
                                    Yes
                                </Button>
                                <Button
                                    color="primary"
                                    style={{ padding: 'auto', width: 100, marginTop: 20 }}
                                    size="sm"
                                    onClick={() => setOpen(false)}
                                    block >
                                    No
                                </Button>
                            </div>
                        </div>
                    </PopupWindow>
                    : <Button color="primary" style={{ marginTop: 10, width: '100%' }} disabled={true} className="border-0 btn-disabled" >Delete Post</Button>
                }

            </Col>
            <Col sm="12" lg="9">
                <Nav tabs>

                    <NavItem>
                        <NavLink
                            className={(activeTab === 'ABOUT') ? 'active' : ''}
                            onClick={() => handleTab('ABOUT')}
                        >
                            About
                        </NavLink>
                    </NavItem>


                    <NavItem>
                        <NavLink
                            className={(activeTab === 'REPORTED_BY') ? 'active' : ''}
                            onClick={() => handleTab('REPORTED_BY')}
                        >
                            Reported By
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={(activeTab === 'VIEWED_BY') ? 'active' : ''}
                            onClick={() => handleTab('VIEWED_BY')}
                        >
                            Viewed By
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} style={{ paddingTop: 30 }}>
                    <TabPane tabId="ABOUT">
                        <div style={{ marginTop: 20 }}>
                            <Row key={1}>
                                <Col sm="6" xs="6">
                                    Username:
                                </Col>
                                <Col sm="6" xs="6">
                                    {props.postInfo.user && props.postInfo.user.username}
                                </Col>
                            </Row>

                            <Row key={1}>
                                <Col sm="6" xs="6">
                                    Total Like:
                                </Col>
                                <Col sm="6" xs="6">
                                    {props.postInfo && props.postInfo.like_count}
                                </Col>
                            </Row>

                            <Row key={1}>
                                <Col sm="6" xs="6">
                                    Total Comments:
                                </Col>
                                <Col sm="6" xs="6">
                                    {props.postInfo && props.postInfo.comment_count}
                                </Col>
                            </Row>

                            <Row key={1}>
                                <Col sm="6" xs="6">
                                    Total Clicks:
                                </Col>
                                <Col sm="6" xs="6">
                                    {props.postInfo && props.postInfo.clicks_count}
                                </Col>
                            </Row>

                            <Row key={1}>
                                <Col sm="6" xs="6">
                                    Total Views:
                                </Col>
                                <Col sm="6" xs="6">
                                    {props.postInfo && props.postInfo.views_count}
                                </Col>
                            </Row>

                            <Row key={1}>
                                <Col sm="6" xs="6">
                                    Total Shares:
                                </Col>
                                <Col sm="6" xs="6">
                                    {props.postInfo && props.postInfo.shares_count}
                                </Col>
                            </Row>

                            <Row key={1}>
                                <Col sm="6" xs="6">
                                    Bookmarked:
                                </Col>
                                <Col sm="6" xs="6">
                                    {props.postInfo && props.postInfo.bookmarks_count}
                                </Col>
                            </Row>

                            <Row key={1}>
                                <Col sm="6" xs="6">
                                    Last Updated:
                                </Col>
                                <Col sm="6" xs="6">
                                    {props.postInfo && DateFormat(props.postInfo.updated_at, 'MM-DD-YYYY')}
                                </Col>
                            </Row>

                            {checkPermissions(props.loginData, 'users_locations') && <div>
                                {(props.isLoading) ?
                                    <Skeleton variant="rectangular" width={'100%'} height={300} style={{ borderRadius: 5 }} />
                                    : <Row>
                                        <Map
                                            center={{
                                                lat: (props.postInfo && props.postInfo.latitude) ? props.postInfo.latitude : 0,
                                                lng: (props.postInfo && props.postInfo.longitude) ? props.postInfo.longitude : 0,
                                            }}
                                            zoom={12}
                                            scrollWheelZoom={true}
                                            style={{ border: '1px solid', borderRadius: '5px', height: (props.height) ? props.height : 300, width: (props.width) ? props.width : '100%' }}>
                                            <TileLayer
                                                noWrap={true}
                                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            />
                                            <Marker
                                                position={[(props.postInfo && props.postInfo.latitude) ? props.postInfo.latitude : 0, (props.postInfo && props.postInfo.longitude) ? props.postInfo.longitude : 0]}
                                                icon={markerIcon}
                                                key={1}
                                            >
                                            </Marker>
                                        </Map>
                                    </Row>
                                }
                            </div>
                            }


                        </div>
                    </TabPane>
                    <TabPane tabId="REPORTED_BY">
                        <PostUsers isLoading={props.isLoading} data={props.reportedBy} count={props.reportedByCount} handleTable={(order, pagination) => {
                            const filters = { id: postId, page: pagination.page, page_limit: pagination.page_limit, order_by: order.order_by, direction: order.direction };
                            props.getReportedBy(filters);
                        }} />
                    </TabPane>
                    <TabPane tabId="VIEWED_BY">
                        <PostUsers isLoading={props.isLoading} data={props.viewedBy} count={props.viewedByCount} handleTable={(order, pagination) => {
                            const filters = { id: postId, page: pagination.page, page_limit: pagination.page_limit, order_by: order.order_by, direction: order.direction };
                            props.getViewedBy(filters);
                        }} />
                    </TabPane>
                </TabContent>
            </Col>
        </Row>
    );
}

const mapStateToProps = (state) => ({
    postInfo: (state.post && state.post.postdetails && state.post.postdetails.post_info) ? state.post.postdetails.post_info : [],
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    postDeleted: (state.post && state.post.postDeleted) ? state.post.postDeleted : null,
    postDetails: (state.post && state.post.postdetails && state.post.postdetails.post) ? state.post.postdetails.post : [],
    reportedBy: (state.post && state.post.reportedBy && state.post.reportedBy.users) ? state.post.reportedBy.users : [],
    reportedByCount: (state.post && state.post.reportedBy && state.post.reportedBy.total_users) ? state.post.reportedBy.total_users : 0,
    viewedBy: (state.post && state.post.viewedBy && state.post.viewedBy.users) ? state.post.viewedBy.users : [],
    viewedByCount: (state.post && state.post.viewedBy && state.post.viewedBy.total_users) ? state.post.viewedBy.total_users : 0,
});
const mapDispatchToProps = (dispatch) => ({
    getReportedBy: (payload) => dispatch(PostAction.reportedBy(payload)),
    getViewedBy: (payload) => dispatch(PostAction.viewedBy(payload)),
    getPostDetails: (payload) => dispatch(PostAction.getPostDetails(payload)),
    deletePost: (payload) => dispatch(PostAction.deletePost(payload)),

});

export default connect(mapStateToProps, mapDispatchToProps)(PostDetails);